// This is a starting template. Do not edit this file directly.
// Dupicate it and modify the new file as needed.

import { Component, Host, Element, getAssetPath, h } from "@stencil/core";

import { MercuryBundles } from "@genexus/mercury";

import { Locale } from "../../common/locale";

const ASSETS_DIR = "gx-ide-assets/sign-in-result";

const LEFT_SIDE_ILLUSTRATION = getAssetPath(
  `./${ASSETS_DIR}/images/left-side-illustration.svg`
);
const RIGHT_SIDE_ILLUSTRATION = getAssetPath(
  `./${ASSETS_DIR}/images/right-side-illustration.svg`
);
const GENEXUS_NEXT_LOGO_SRC = getAssetPath(
  `./${ASSETS_DIR}/images/genexus-next-logo.svg`
);

const CSS_BUNDLES: MercuryBundles = [
  // Use only the bundles that are needed for this component.
  "resets/box-sizing",
  "utils/typography",
  "utils/spacing"
];

@Component({
  tag: "gx-ide-sign-in-result",
  styleUrl: "sign-in-result.scss",
  shadow: true,
  assetsDirs: ["gx-ide-assets/sign-in-result"]
})
export class GxIdeSignInResult {
  _componentLocale: any;

  @Element() el: HTMLGxIdeSignInResultElement;

  async componentWillLoad() {
    this._componentLocale = await Locale.getComponentStrings(this.el);
  }

  componentDidLoad() {}

  render() {
    return (
      <Host
        class="widget spacing-body"
        style={{
          backgroundImage: `url('${LEFT_SIDE_ILLUSTRATION}'), url('${RIGHT_SIDE_ILLUSTRATION}')`,
          backgroundRepeat: "no-repeat, no-repeat",
          backgroundPosition: "left, right bottom",
          backgroundSize: "auto 100%, auto 55%"
        }}
      >
        <ch-theme model={CSS_BUNDLES}></ch-theme>
        <div class="content">
          <span class="check-icon"></span>
          <h1 class="heading-3">{this._componentLocale.title}</h1>
          <p class="subtitle-regular-s">{this._componentLocale.description}</p>
          <div
            style={{
              mask: `url(${GENEXUS_NEXT_LOGO_SRC}) no-repeat center / contain`
            }}
            class="genexus-next-logo"
          />
        </div>
      </Host>
    );
  }
}

export type CancelCallback = () => Promise<void>;

export type SaveCallback = () => Promise<string>;
